import React from 'react';
import {
  DateTimePicker as MuiDateTimePicker,
  DateTimePickerProps as MuiDateTimePickerProps,
} from '@mui/x-date-pickers';
import { Field, FieldProps, FieldRenderProps } from 'react-final-form';

import { useCanEditFormFieldsContext } from '@occc-app/App/CanEditFormFieldsContext';

import { ShowErrorFunc, showErrorOnChange } from './rff/Util';

interface DateTimePickerWrapperProps extends FieldRenderProps<MuiDateTimePickerProps<Date>> {
  required?: boolean;
  locale?: any;
}

function DateTimePickerWrapper(props: DateTimePickerWrapperProps) {
  const {
    input: { name, onChange, value, ...restInput },
    meta,
    showError = showErrorOnChange,
    required,
    helperText,
    ...rest
  } = props;

  const { error, submitError } = meta;
  const isError = showError({ meta });

  return (
    <MuiDateTimePicker
      onChange={onChange}
      value={value || null}
      slotProps={{
        textField: {
          name,
          required,
          fullWidth: true,
          helperText: isError ? error || submitError || helperText : helperText,
          error: isError,
          inputProps: {
            onBlur: restInput.onBlur,
            onFocus: restInput.onFocus,
          },
        },
      }}
      {...rest}
    />
  );
}

export interface DateTimePickerProps
  extends Partial<Omit<MuiDateTimePickerProps<Date>, 'onChange'>> {
  name: string;
  locale?: any;
  fieldProps?: Partial<FieldProps<any, any>>;
  required?: boolean;
  showError?: ShowErrorFunc;
}

export function KeyboardDateTimePicker(props: DateTimePickerProps) {
  const { isEditable } = useCanEditFormFieldsContext();
  const { name, fieldProps, required, disabled, ...rest } = props;
  const isDisabled = disabled || !isEditable;

  return (
    <Field
      name={name}
      render={(fieldRenderProps) => <DateTimePickerWrapper {...fieldRenderProps} {...rest} />}
      required={required}
      disabled={isDisabled}
      {...fieldProps}
    />
  );
}
